import axios from 'axios';

// ─── Profile-based URL resolver ───────────────────────────────────────────────
// Change REACT_APP_PROFILE in .env to switch environment: dev | qa | uat | prod
const PROFILE_URLS = {
  dev:  process.env.REACT_APP_API_URL_DEV  || 'http://localhost:8080',
  qa:   process.env.REACT_APP_API_URL_QA   || 'https://qa-api.walkbattle.in',
  uat:  process.env.REACT_APP_API_URL_UAT  || 'https://uat-api.walkbattle.in',
  prod: process.env.REACT_APP_API_URL_PROD || 'https://app.walkbattle.in',
};

const PROFILE  = process.env.REACT_APP_PROFILE || 'dev';
const BASE_URL = PROFILE_URLS[PROFILE] || PROFILE_URLS.dev;

// eslint-disable-next-line no-console
console.info(`[WalkBattle] Profile: ${PROFILE.toUpperCase()} → ${BASE_URL}`);

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

// ─── Request Interceptor: attach JWT ─────────────────────────────────────────
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('wb_admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── Response Interceptor: handle 401 ────────────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid — clear session and redirect to login
      localStorage.removeItem('wb_admin_token');
      localStorage.removeItem('wb_admin_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
